// Design system colors
export const DESIGN_COLORS = {
  status: {
    success: '#059669',
    warning: '#d97706',
    error: '#dc2626',
    neutral: '#6b7280',
  },
};

// Status to color mapping
const STATUS_COLOR_MAP = {
  // Success statuses
  active: DESIGN_COLORS.status.success,
  published: DESIGN_COLORS.status.success,
  approved: DESIGN_COLORS.status.success,
  confirmed: DESIGN_COLORS.status.success,
  complete: DESIGN_COLORS.status.success,
  completed: DESIGN_COLORS.status.success,
  paid: DESIGN_COLORS.status.success,
  verified: DESIGN_COLORS.status.success,
  specific: DESIGN_COLORS.status.success,
  returned: DESIGN_COLORS.status.success,
  // Warning statuses
  pending: DESIGN_COLORS.status.warning,
  ended: DESIGN_COLORS.status.warning,
  reported: DESIGN_COLORS.status.warning,
  // Error statuses
  terminated: DESIGN_COLORS.status.error,
  rejected: DESIGN_COLORS.status.error,
  inactive: DESIGN_COLORS.status.error,
  unpaid: DESIGN_COLORS.status.error,
  draft: DESIGN_COLORS.status.error,
  cancelled: DESIGN_COLORS.status.error,
  unspecific: DESIGN_COLORS.status.error,
  refused: DESIGN_COLORS.status.error,
};

/**
 * Get the color for a given status
 * @param {string} status - The status string to get color for
 * @returns {string} - Hex color code for the status
 */
export const getStatusColor = (status) => {
  if (!status) return DESIGN_COLORS.status.neutral;
  const normalizedStatus = status.toLowerCase().trim();
  return STATUS_COLOR_MAP[normalizedStatus] || DESIGN_COLORS.status.neutral;
};

/**
 * Get the status badge color scheme for Chakra UI
 * Maps to Chakra's colorScheme prop values
 * @param {string} status - The status string
 * @returns {string} - Chakra color scheme (green, yellow, red, gray)
 */
export const getStatusBadgeColor = (status) => {
  if (!status) return 'gray';
  const normalizedStatus = status.toLowerCase().trim();

  const successStatuses = ['active', 'published', 'approved', 'confirmed', 'complete', 'completed', 'paid', 'verified', 'specific'];
  const warningStatuses = ['pending', 'ended', 'reported'];
  const errorStatuses = ['terminated', 'rejected', 'inactive', 'unpaid', 'draft', 'cancelled', 'unspecific', 'refused'];

  if (successStatuses.includes(normalizedStatus)) return 'green';
  if (warningStatuses.includes(normalizedStatus)) return 'yellow';
  if (errorStatuses.includes(normalizedStatus)) return 'red';
  return 'gray';
};

const statusColorMapDefault = {
  getStatusColor,
  getStatusBadgeColor,
  DESIGN_COLORS,
};

export default statusColorMapDefault;
